import React, { useState } from 'react';

const IconButton = ({
  icon: Icon,
  tooltip,
  onClick,
  variant = 'default',
  className = '',
  ...props
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const variantClasses = {
    default: 'text-gray-600 hover:text-gray-900 hover:bg-gray-100',
    primary:
      'text-primary-600 hover:text-primary-700 hover:bg-primary-50 disabled:text-gray-400 disabled:hover:bg-transparent',
    danger: 'text-red-600 hover:text-red-700 hover:bg-red-50',
  };

  return (
    <div className='relative inline-block'>
      <button
        type='button'
        onClick={onClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className={`p-2 rounded-lg transition-colors ${variantClasses[variant]} ${className}`}
        {...props}
      >
        <Icon className='w-5 h-5' />
      </button>
      {showTooltip && tooltip && (
        <div className='absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-1.5 bg-gray-900 text-white text-xs rounded-lg whitespace-nowrap z-50 pointer-events-none'>
          {tooltip}
          <div className='absolute top-full left-1/2 transform -translate-x-1/2 -mt-1'>
            <div className='border-4 border-transparent border-t-gray-900' />
          </div>
        </div>
      )}
    </div>
  );
};

export default IconButton;
